











import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { AppUtil } from '../../utils/app.util';
import userService from '@/service/userService';
import LoginComponent from './login.vue'
import RegisterComponent from './register.vue'
import SetPasswd from './set-passwd.vue'
import { State, Action, Getter } from 'vuex-class'

@Component({
  components: {
    LoginComponent,
    RegisterComponent,
    SetPasswd
  }
})
export default class AccountComponent extends Vue {
  private showModel: boolean = false;
  private dialogTitle: string = '登录' // 弹窗标题
  private type: string = 'login' // 类型：login 登录 register 注册 setPasswd 设置密码
  @State('accountDialogType') private accountDialogType!: string // 类型
  @State('showAccountDialog') private showAccountDialog!: string // 类型
  @Action('SET_SHOW_ACCOUNT_DIALOG_ASYN') handleAccountDialog!: (data: boolean) => void
  @Emit('sendAfter') private sendAfter(res: boolean) {
    return res
  }

  @Watch('showAccountDialog', { immediate: true, deep: true })
  onShowAccountDialogChange(newVal: boolean) {
    this.showModel = newVal
    // 这里可以执行其他需要在 userName 变化时执行的逻辑
  }
  @Watch('accountDialogType', { immediate: true, deep: true })
  onAccountDialogTypeChange(newVal: string) {
    this.dialogTitle = newVal === 'login' ? '登录' : newVal === 'register' ? '注册' : '设置密码'
  }

  onCancel() {
    this.handleAccountDialog(false)
    this.showModel = false;

  }
}
